import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import Image from "src/Common/Image";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_NOT_DEMO_TCA_1 = {
  title:
    "John has been tasked with taking care of \nthe network operation of Globe Connect.\n Here you will see how Telco Cloud\n Automation will help his process",
  subtitle: "Network operation team",
  text: "John manages daily operations, monitoring, and maintenance \nof the company's computer network, ensuring efficiency,\n security, and alignment with organizational needs. His team\n collaborates for seamless services across diverse IT operations.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_313"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      setCurrentPage(previousPage());
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  rightSideComponent: (
    <div style={{ position: "absolute", bottom: "0", right: "0" }}>
      <div
        style={{
          position: "relative",
          width: "833px",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <Image
          styleImage={{
            position: "absolute",
            bottom: "121px",
            right: "651px",
            zIndex: 1,
          }}
          imagePath="ILO/TCA/TCA_NOT_Demo_1_name.png"
        />
        <Image
          styleImage={{
            position: "absolute",
            width: "845px",
            height: "auto",
            bottom: "0px",
            right: "-121px",
          }}
          imagePath="ILO/characters/character_2.gif"
        />
      </div>
    </div>
  ),
};
